<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/timeline">Timeline</router-link>
  </nav> -->
  <!-- <NavLink /> -->
  <!-- <transition name="fade" mode="out-in">
  </transition> -->

  <div id="app" class="theme_a_all_wrap">
    <!-- Start leftpart -->
    <MainLayout />
    <!-- End rightpart -->
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import NavLink from "@/components/NavLink.vue"; // @ is an alias to /src
import MainLayout from "@/layouts/mainLayout.component.vue"; // @ is an alias to /src

@Options({
  components: {
    NavLink,
    MainLayout
  },
})
export default class App extends Vue {


}
</script>

<style lang="scss">
#app {
  //font-family: "Raleway", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.fade-move,
.fade-enter-active,
.fade-leave-active {
  // opacity: 1;
  transition: opacity 0.2s ease;
}
// .fade-enter-active {
//   transition-delay: 1000ms;
//   transition: opacity 0.2s ease-in-out;
// }
// .fade-leave-active {
//   transition: opacity 0.2s ease-in-out;
// }

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-leave-active {
  transition: position 0s ease;
  position: absolute;
}

nav {
  position: relative;
  .line {
    height: 2px;
    position: absolute;
    bottom: 0;
    margin: 10px 0 0 0;
    background: #ff1847;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    display: flex;
    li {
      margin: 0 40px 0 0;
      transition: all 0.4s ease;
      a {
        opacity: 0.4;
        &:hover {
          opacity: 0.7;
        }
      }
      &:last-child {
        margin-right: 0;
      }
      a {
        text-decoration: none;
        text-transform: uppercase;
        display: block;
        font-weight: 600;
        letter-spacing: 0.2em;
        font-size: 14px;
      }
    }
  }
}
.router-link-active.router-link-exact-active {
  opacity: 1;
}
</style>
